import { createReducer } from '@reduxjs/toolkit';
import { subMonths } from 'date-fns';

import { OrdersStateType } from '../../types';
import {
  fetchOrdersChanges,
  fetchOrdersRoles,
  fetchOrdersStatuses,
  fetchUserOrders,
  setFiltersQuery,
  setInitialOrders,
  setOrdersFilter,
  setOrdersLoading,
  setPage,
  setPeriodData,
  setSelectFilter,
} from '../actions/orders';

let initFilter: any = localStorage.getItem('ordersFilter');
if (initFilter) {
  initFilter = JSON.parse(initFilter);
}

const initialState: OrdersStateType = {
  loading: {
    orders: false,
    roles: false,
  },
  data: {
    roles: [],
    statuses: [],
    pagination: {
      isFirst: true,
      isLast: false,
    },
    filters: initFilter
      ? {
          ...initFilter,
          page: {
            number: 0,
            size: 8,
          },
        }
      : {
          role: 'INITIATOR',
          orderStatuses: '',
          refNumber: {
            direction: 'ASC',
            show: false,
          },
          search: '',
          amount: {
            show: false,
            direction: 'ASC',
          },
          period: {
            show: true,
            direction: 'ASC',
          },
          periodData: {
            from: subMonths(new Date(), 1),
            to: new Date(),
          },
          page: {
            number: 0,
            size: 8,
          },
        },
    orders: [],
    changes: [],
  },
};

const ordersReducer = createReducer(initialState, (builder) => {
  builder.addCase(setOrdersLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });
  builder.addCase(fetchOrdersRoles.fulfilled, (state, action) => {
    state.data.roles = action.payload;
  });
  builder.addCase(setFiltersQuery, (state, action) => {
    state.data.filters.search = action.payload;
    localStorage.setItem('ordersFilter', JSON.stringify(state.data.filters));
  });
  builder.addCase(setOrdersFilter, (state, action) => {
    if (action.payload.type === 'amount') {
      state.data.filters.period.show = false;
      state.data.filters.refNumber.show = false;
    } else if (action.payload.type === 'refNumber') {
      state.data.filters.amount.show = false;
    }
    state.data.filters[action.payload.type].show = true;
    state.data.filters[action.payload.type].direction = action.payload.value;
    localStorage.setItem('ordersFilter', JSON.stringify(state.data.filters));
  });
  builder.addCase(setPage, (state, action) => {
    state.data.filters.page.number = action.payload;
  });
  builder.addCase(fetchUserOrders.fulfilled, (state, action) => {
    if (action.payload.concat) {
      state.data.orders = state.data.orders.concat(action.payload.orders);
    } else {
      state.data.orders = action.payload.orders;
    }
    state.data.pagination.isFirst = action.payload.pagination.isFirst;
    state.data.pagination.specialFields =
      action.payload.pagination.specialFields;
    state.data.pagination.isLast = action.payload.pagination.isLast;
    state.data.pagination.total = action.payload.pagination.total;
  });
  builder.addCase(setSelectFilter, (state, action) => {
    state.data.orders = initialState.data.orders;
    if (!Array.isArray(action.payload.value)) {
      state.data.filters[action.payload.type] = action.payload.value;
      localStorage.setItem('ordersFilter', JSON.stringify(state.data.filters));
    }
  });
  builder.addCase(setInitialOrders, (state) => {
    state.data.orders = initialState.data.orders;
  });
  builder.addCase(setPeriodData, (state, action) => {
    state.data.filters.periodData.from = action.payload.from;
    state.data.filters.periodData.to = action.payload.to;
    localStorage.setItem('ordersFilter', JSON.stringify(state.data.filters));
  });
  builder.addCase(fetchOrdersStatuses.fulfilled, (state, action) => {
    state.data.statuses = action.payload;
  });
  builder.addCase(fetchOrdersChanges.fulfilled, (state, action) => {
    // @ts-ignore // TODO: fix me
    state.data.changes = action.payload;
  });
});

export default ordersReducer;
